import {RouterType} from 'hostApplicationStoreType';
import {getAffId} from 'libs/analytics/affiliate';
/**
 * Get affiliate code
 * @returns {{affiliate_code: string}} - affiliateCode
 */
export function getAffiliateCode(meta: {router: RouterType | null}): {
    affiliate_code?: string;
} {
    const search = meta?.router?.location?.search;
    const affiliateCode = getAffId({search});
    return affiliateCode ? {affiliate_code: affiliateCode} : {};
}
